import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

import { Spin } from 'antd';

const root = createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <Suspense
      fallback={<Spin size="large" className="vh-100 w-full flex-1 d-flex justify-content-center align-items-center" />}
    >
      <App />
    </Suspense>
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
